const { default: styled } = require('styled-components');

const StyledInput = styled.input`
  ${(props) =>
    props.disabled &&
    props.checked &&
    `
    appearance: none;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    border: 2px solid green;
    background-color: green;
`}
`;

export const StyledStrong = styled.strong`
  color: #32325d;
  margin-bottom: 10px;
  display: block;
  text-transform: uppercase;
  font-weight: 600;
`;

export default StyledInput;
